import { ComponentPropsWithRef, ElementType } from 'react'
import { observer } from 'mobx-react-lite'

type DebugButtonProps = {
    Icon?: ElementType<ComponentPropsWithRef<'svg'>>
    onClick: () => void
}

export const DebugButton = observer(({ Icon, onClick }: DebugButtonProps) => (
    <div className="p-2 text-white hover:bg-white/10 active:bg-black/20" onClick={onClick}>
        {Icon && <Icon className="h-5 w-5" />}
    </div>
))
